import { colors } from "../../config/Colors";
import SegmentTabBar from "../../components/Profile/SegmentTabBar";
import UserProfileInfoCard from "../../components/Profile/UserProfileInfoCard";

import React, { useContext, useEffect, useState } from 'react';
import { ActivityIndicator, View, SafeAreaView, Text, Button, TouchableOpacity, Image, ScrollView, FlatList, StyleSheet } from 'react-native';
import { ids } from '../../styles/global';
import { API } from '../../lib/api';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import CollectionItem from '../../components/collectionItem'
import { AuthContext } from '../../context';
import Header from "../../components/Common/userHeader";
import { useLinkProps, useNavigation } from '@react-navigation/native';
import IconButton from '../../components/iconButton';
import FeedItem from "../../components/Home/FeedItem";

export default function UserProfileScreen({ route }) {
  const { id } = route.params;
  const authContext = useContext(AuthContext);
  const [user, setUser] = useState(null);

  useEffect(() => {
    API.user(id).then(setUser).catch(err => {
      // TODO: provide a better "failed to load" screen.
      console.log(err);
    });
  }, [authContext.user, id]);

  const [selectedMenuItemKey, setSelectedMenuItemKey] = useState('2');
  const [menuVisible, setMenuVisible] = useState(null);
  const menuOptions = [
    { key: "1", label: "Edit profile" },
    { key: "2", label: "Account Settings" },
    { key: "3", label: "Sign Out" },
  ];
  const renderMenuOption = ({ item }) => (
    <TouchableOpacity
      style={[
        styles.menuOption,
        item.key === selectedMenuItemKey ? styles.menuOptionSelected : {},
      ]}
      onPress={() => onSelectMenuOption(item)}
    >
      <Text style={styles.menuOptionText}>{item.label}</Text>
    </TouchableOpacity>
  );

  const onSelectMenuOption = (option) => {
    setSelectedMenuItemKey(option.key);
    console.log("Selected option:", option.label);
    setMenuVisible(false);
  };

  return (
    <View style={styles.containerContainer}>
      {
        user == null ?
        <></>
        :
        <>
          <Header
            icon={require("../../assets/icons/Common/follow-icon.png")}
            title={"User Profile"}
            user={user}
            setUser={setUser}
          />
          {menuVisible && (
            <View style={styles.menuContainer}>
              <FlatList
                data={menuOptions}
                renderItem={renderMenuOption}
                keyExtractor={(item) => item.key}
              />
            </View>
          )}
          <View style={styles.container}>
            <View style={{ flex: 1 }}>
              <UserProfileInfoCard user={user}/>
              <SegmentTabBar userId={user.id} />
            </View>
          </View>
        </>
      }
    </View>
  );
}

const styles = StyleSheet.create({
  scrollArea: {
    flex: 1,
    backgroundColor: "white",
  },
  containerContainer: {
    backgroundColor: "white",
    flex: 1
  },
  container: {
    flex: 1,
    backgroundColor: colors.white,
    maxWidth: 500,
    marginTop: 0,
    padding: 0,
    marginTop: 0,
    paddingTop: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: 0
  },
  menuContainer: {
    position: "absolute",
    top: 160,
    right: 15,
    backgroundColor: "white",
    borderWidth: 2,
    borderColor: colors.border,
    borderRadius: 5,
    minWidth: 144,
    zIndex: 5
  },
  menuOption: {
    padding: 10,
    zIndex: 999999,
  },
  menuOptionText: {
    color: colors.primary,
    fontSize: 14,
    fontFamily: "Regular",
  },
  menuOptionSelected: {
    backgroundColor: "white"
  },
  contentContainer: { zIndex: -99999,
  backgroundColor: "white"
}
});
